import { createSlice } from "@reduxjs/toolkit";

export const OrderSlice = createSlice({
  name: "Order",
  initialState: {
    val: {
      username: "",
      gender: "",
      fullName: "",
    },
    service: [],
    option: [],
  },
  reducers: {
    OrderValue: (state, action) => {
      state.val = action.payload;
    },
    rowValue: (state, action) => {
      state.val = action.payload;
    },
    serviceValue: (state, action) => {
      state.service = action.payload;
    },
    optionValue: (state, action) => {
      state.option = action.payload;
    },
  },
});

export const { OrderValue, serviceValue, optionValue } = OrderSlice.actions;

export default OrderSlice.reducer;
